import form						from './modules/form/form';
import formSumField				from './modules/form/form-sum-field';
import app           			from '../shared/shared';

app.registerModules([
	form,
	formSumField
]);
